module.exports = __webpack_public_path__ + "img/security-audit-img-4.73aa259c.webp";